export default __webpack_public_path__ + "static/media/ck.3e6dd6dd.svg";